import { render, staticRenderFns } from "./multifileUpdate.vue?vue&type=template&id=4fbc0a41&scoped=true"
import script from "./multifileUpdate.vue?vue&type=script&lang=js"
export * from "./multifileUpdate.vue?vue&type=script&lang=js"
import style0 from "./multifileUpdate.vue?vue&type=style&index=0&id=4fbc0a41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbc0a41",
  null
  
)

export default component.exports